import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudTypographyModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { JourneyAppointmentIconModule } from '../journey-appointment-icon/journey-appointment-icon.module';
import { JourneyBoardComponent } from './journey-board.component';

@NgModule({
	declarations: [JourneyBoardComponent],
	imports: [
		CommonModule,
		TranslateModule.forRoot(),
		FreudTypographyModule,
		JourneyAppointmentIconModule,
	],
	exports: [JourneyBoardComponent],
})
export class JourneyBoardModule {}
